import { faArrowDown, faArrowUp, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FC } from "react";

export const TrendArrow: FC<{
  trend: "up" | "down" | "flat" | null;
  trendStyle?: "green" | "red" | "slate" | null;
}> = (props) => {
  if (!props.trend) {
    return <></>;
  }
  const trendStyle = props.trendStyle
    ? { green: "text-green-700", red: "text-red-700", slate: "text-slate-400" }[props.trendStyle]
    : props.trend === "up"
      ? "text-green-700"
      : props.trend === "down"
        ? "text-red-700"
        : "text-slate-400";
  const icon = props.trend === "up" ? faArrowUp : props.trend === "down" ? faArrowDown : faMinus;
  return <FontAwesomeIcon className={`text-sm ${trendStyle}`} icon={icon} />;
};
